import Resource from '@/api/resources/Resource'

class RoleConfigurationServices extends Resource {
    async paginator(filterModel, params) {
        const response = await this.axios.put(`/configuration/roles`, filterModel, { params })
        return response.data
    }
    async getRolesByName(params) {
        const response = await this.axios.get(`/configuration/roles/search`, { params })
        return response.data
    }
    async patchRole(role) {
        const response = await this.axios.patch(`/configuration/roles/batch`, role)
        return response.data
    }
    async createRole(role) {
        const response = await this.axios.post(`/configuration/roles`, role)
        return response.data
    }
    async deleteRolesBatch(roles) {
        const data = {
            entityIdentifiers: roles
        }
        const response = await this.axios.delete(`/configuration/roles/batch`, { data: data })
        return response.data
    }
}

export default new RoleConfigurationServices()
